import { DispatchCard, UnassignedItem } from 'src/entities/dispatch';

export type AutoDispatchOverrideState = {
  overrideRowCount: number;
  hasOverrideUnassigned: boolean;
  hasQueuedOverrideChange: boolean;
};

export function shouldResetOverrideAfterServerRefresh({
  overrideRowCount,
  hasOverrideUnassigned,
  hasQueuedOverrideChange,
}: AutoDispatchOverrideState): boolean {
  return overrideRowCount === 0 && !hasOverrideUnassigned && !hasQueuedOverrideChange;
}

export function shouldClearOverrideAfterPlanningResult(hasQueuedOverrideChange: boolean): boolean {
  return !hasQueuedOverrideChange;
}

export type OverrideResetHandles = {
  setOverrideRowCards: (next: Map<string, DispatchCard[]>) => void;
  setOverrideUnassigned: (next: UnassignedItem[] | null) => void;
  hasQueuedOverrideChangeRef: { current: boolean };
};

/**
 * scope（会社・対象日）が変わったら D&D 楽観的上書きを破棄する。
 * shouldResetOverrideAfterServerRefresh は override が入っている間はサーバ再取得だけでは
 * クリアしない設計（進行中の自動配車の途中経過を守るため）なので、scope 変更時は
 * ここで明示的にクリアする。ConvenienceDispatches/Presenter.tsx の handleScopeChanged が呼ぶ。
 */
export function resetOverrideForScopeChange({
  setOverrideRowCards,
  setOverrideUnassigned,
  hasQueuedOverrideChangeRef,
}: OverrideResetHandles): void {
  hasQueuedOverrideChangeRef.current = false;
  setOverrideRowCards(new Map());
  setOverrideUnassigned(null);
}
